module.exports = __webpack_public_path__ + "static/images/checkmark-in-circle.bb6571a25e81422b1254f7233dd315c2.svg";